export const formatPrice = (value: string | number) => {
  const formatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

  return formatter.format(parseFloat(value as string));
};
